import { render } from "./yos-loading.vue?vue&type=template&id=47401014"
import script from "./yos-loading.vue?vue&type=script&lang=js"
export * from "./yos-loading.vue?vue&type=script&lang=js"

import "./yos-loading.vue?vue&type=style&index=0&id=47401014&lang=postcss"
script.render = render

export default script